import { isCookieEnabled, getCookie, setCookie, removeCookie } from 'tiny-cookie'

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value
}

const VueCookie = {
  install (Vue) {
    Vue.prototype.$cookie = this
    Vue.Cookie = this
  },
  get (key) {
    return getCookie(key)
  },
  set (key, value, options) {
    if (Number.isInteger(options)) {
      options = {expires: options}
    }
    setCookie(key, value, options)
  },
  remove (key, options) {
    removeCookie(key, options)
  },
  isEnabled: isCookieEnabled()
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueCookie)
}

export default VueCookie



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js